let lodash = require("lodash");

function spawnConfirmation(spec) {
    if (!spec) {
        spec = {};
    }
    spec.id = spec.id || Date.now();
    spec.setState = () => {
    };
    spec.close = () => {
    };
    let prom = new Promise((resolve, reject) => {
        spec.resolve = resolve;
        spec.reject = reject;
    });
    spec.promise = prom;

    if (!spawnConfirmation.setDialogs) {
        spec.reject();
        return prom;
    }

    prom.finally(() => {
        spawnConfirmation.setDialogs(spawnConfirmation.getDialogs().filter((xspec) => xspec.id !== spec.id));
    });
    let current = spawnConfirmation.getDialogs();
    let existing = lodash.find(current, {id: spec.id});
    if (!existing) {
        spawnConfirmation.setDialogs([spec, ...current]);
    } else {
        prom = existing.promise;
    }
    return prom;
}

export default spawnConfirmation;